import React from 'react';
import { Form } from 'react-bootstrap';
import { useTranslate } from '@tolgee/react';

import styles from './LomavisRadiusSelector1.module.css';

export interface LomavisRadiusSelector1Props {
  valueKm: number;
  onChange: (valueKm: number) => void;
  minKm?: number;
  maxKm?: number;
  stepKm?: number;
}

export const LomavisRadiusSelector1: React.FC<LomavisRadiusSelector1Props> = ({
  valueKm,
  onChange,
  minKm = 5,
  maxKm = 100,
  stepKm = 1
}) => {
  const { t } = useTranslate();
  const midpointKm = Math.round((minKm + maxKm) / 2);

  return (
    <div className="vstack gap-3">
      <div className="d-flex justify-content-between gap-3">
        <div>
          <div className="fw-bold text-body">
            {t('adManager.targeting.radius', 'Radius')}
          </div>
          <div className="text-muted small fw-semibold">
            {t('adManager.targeting.appliesToAll', 'applies to all')}
          </div>
        </div>
        <div className="text-end">
          <div className="display-6 fw-bold lh-1">{valueKm}</div>
          <div className="text-muted small fw-bold">
            {t('adManager.units.km', 'km')}
          </div>
        </div>
      </div>
      <Form.Range
        className={styles.range}
        min={minKm}
        max={maxKm}
        step={stepKm}
        value={valueKm}
        aria-label={t(
          'adManager.targeting.radiusInKilometers',
          'Radius in kilometers'
        )}
        onChange={(event) => onChange(Number(event.currentTarget.value))}
      />
      <div className="d-flex justify-content-between gap-3 text-muted small fw-semibold">
        <span>{minKm}km</span>
        <span>{midpointKm}km</span>
        <span>{maxKm}km</span>
      </div>
    </div>
  );
};
